module.exports = __webpack_public_path__ + "media/entities/2311-df002e55.png";